import { NotesWithAuthor } from "../api/client";
import { Hr } from "./Hr";
import { StudentNotesDescription } from "./StudentNotesDescription";
import { DateTime } from "luxon";
import { PencilSquare, StickyFill, Trash3Fill } from "react-bootstrap-icons";
import { Button } from "./UiComponents/button";

interface StudentNoteElementProps {
    note: NotesWithAuthor
    scrollToRichTextEditor: (text: string, noteId: string) => {}
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setNoteId: React.Dispatch<React.SetStateAction<string | null>>
}

export function StudentNoteElement({note, scrollToRichTextEditor, setIsOpen, setNoteId}: StudentNoteElementProps): JSX.Element {
    return (
        <div key={note.noteId} id={`note-${note.noteId}`} className='border bg-gray-100 dark:bg-gray-600 dark:border-gray-600 rounded-lg mb-4 p-4'>
            <div className="flex">
                <StickyFill className="w-7 h-7 opacity-90 mr-2 mt-1"/>
                <h2>Advisor Note</h2>
            </div>
            <Hr/>
            <StudentNotesDescription note={note}/>
            <div className='flex justify-between items-center mt-2 flex-wrap'>
                <div className='flex gap-2 '>
                    <Button
                        variant="default"
                        onClick={() => {scrollToRichTextEditor(note.content?.toString() || '', note.noteId?.toString() || '')}}
                        abbr="Click to edit the note"
                    >
                        <span>Edit</span>
                        <PencilSquare className="w-4 h-4"/>
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={() => {setIsOpen(true); setNoteId(note.noteId?.toString() || '');}}
                        abbr="Click to delete the note"
                    >
                        <span>Delete</span>
                        <Trash3Fill className="w-4 h-4"/>
                    </Button>
                </div>
                <div className='text-sm text-gray-500 dark:text-gray-400 mr-2 mt-3 md:mt-0'>
                  {note.createdAt && note.modifiedAt && note.createdAt?.equals(note.modifiedAt) ? `Created by  ${note.advisorFullname} on ${DateTime.fromISO(note.createdAt?.toString() || '').toLocaleString(DateTime.DATETIME_FULL)} ` : `Edited by ${note.advisorFullname} on ${DateTime.fromISO(note.modifiedAt?.toString() || '').toLocaleString(DateTime.DATETIME_FULL)} `}
                </div>
            </div>
        </div>
    );
}